var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperplaneDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#171920",
    fillOpacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 46,
    stroke: "#FFD52E",
    strokeWidth: 8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0684 55.9165L37.0451 66.7806L78.7364 31.9404L76.954 32.1904L33.0684 55.9165Z",
    fill: "#FFE991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0449 66.7808L45.6852 61.4111L42.3937 60.2871L37.0449 66.7808Z",
    fill: "#FFF6C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5997 31.5664L33.0688 55.9172L21 48.7988L78.5997 31.5664Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1484 31.4414L78.6002 31.5661L42.394 60.2872L53.7767 68.0295L79.1484 31.4414Z",
    fill: "#FFD52E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplaneDark);
export default __webpack_public_path__ + "static/media/paperplane-dark.85ef70cf3f1abb29e1616390f12624bf.svg";
export { ForwardRef as ReactComponent };